/** @format */

(function ($) {
	$(function () {
		var count = $(".insta-feed-slider").children().length;
		const isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;
		if (
			isMobile || count >= 7 ||
			navigator.userAgent.match(/Android/i) ||
			navigator.userAgent.match(/webOS/i) ||
			navigator.userAgent.match(/iPhone/i) ||
			navigator.userAgent.match(/iPad/i) ||
			navigator.userAgent.match(/iPod/i) ||
			navigator.userAgent.match(/BlackBerry/i) ||
			navigator.userAgent.match(/Windows Phone/i)
		) {
			$(".feed-slider").slick({
				dots: false,
				infinite: true,
				speed: 300,
				slidesToShow: 6,
				slidesToScroll: 1,
				adaptiveHeight: true,
				prevArrow:
					'<button type="button" class="insta-slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="52.2" viewBox="0 0 512 512"><title></title><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z" style="fill:#000"></path></g></svg></button>',
				nextArrow:
					'<button type="button" class="insta-slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="52.2" viewBox="0 0 512 512" class="insta-feed-home"><title></title><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z" style="fill:#000"></path></g></svg></button>',
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 6,
							slidesToScroll: 1,
							infinite: true,
							dots: false,
							prevArrow:
								'<button type="button" class="insta-slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="52.2" viewBox="0 0 512 512"><title></title><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z" style="fill:#000"></path></g></svg></button>',
							nextArrow:
								'<button type="button" class="insta-slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="52.2" viewBox="0 0 512 512" class="insta-feed-home"><title></title><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z" style="fill:#000"></path></g></svg></button>',
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 6,
							slidesToScroll: 1,
							infinite: true,
							dots: false,
							prevArrow:
								'<button type="button" class="insta-slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="52.2" viewBox="0 0 512 512"><title></title><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z" style="fill:#000"></path></g></svg></button>',
							nextArrow:
								'<button type="button" class="insta-slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="52.2" viewBox="0 0 512 512" class="insta-feed-home"><title></title><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z" style="fill:#000"></path></g></svg></button>',
						},
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							prevArrow:
								'<button type="button" class="insta-slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="52.2" viewBox="0 0 512 512"><title></title><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z" style="fill:#000"></path></g></svg></button>',
							nextArrow:
								'<button type="button" class="insta-slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="52.2" viewBox="0 0 512 512" class="insta-feed-home"><title></title><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z" style="fill:#000"></path></g></svg></button>',
						},
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
							prevArrow:
								'<button type="button" class="insta-slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="52.2" viewBox="0 0 512 512"><title></title><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z" style="fill:#000"></path></g></svg></button>',
							nextArrow:
								'<button type="button" class="insta-slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="52.2" viewBox="0 0 512 512" class="insta-feed-home"><title></title><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z" style="fill:#000"></path></g></svg></button>',
						},
					},
				],
			});
		}
	});
})(jQuery);
